"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var rql_1 = require("../../schemas/rql");
var bind_1 = require("../../bind");
var update_offer_modal_1 = require("./update_offer_modal");
var classNames = require("classnames");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var refresh_dashboard_1 = require("./refresh_dashboard");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var UpdateOfferButton = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateOfferButton, _super);
    function UpdateOfferButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            openDialog: false,
        };
        return _this;
    }
    UpdateOfferButton.prototype.toggleModal = function () {
        var _this = this;
        this.setState({ openDialog: !this.state.openDialog }, function () {
            if (_this.state.openDialog) {
                tracker_1.trackInteraction({
                    componentName: 'UpdateOfferButton',
                    entityId: _this.props.listingId,
                    type: tracker_1.LISTING_TYPE,
                    context: {
                        negotiationAction: _this.props.negotiationAction,
                    },
                });
            }
        });
    };
    Object.defineProperty(UpdateOfferButton.prototype, "offerButtonText", {
        get: function () {
            var action = this.props.negotiationAction.toLocaleLowerCase();
            return I18n.t("discovery.offers.action." + action);
        },
        enumerable: true,
        configurable: true
    });
    UpdateOfferButton.prototype.handleClose = function () {
        this.setState({ openDialog: false });
    };
    UpdateOfferButton.prototype.handleSuccess = function (requestingParty) {
        var updateOfferMessage = I18n.t('discovery.offers.updateSubmissionSuccess');
        refresh_dashboard_1.refreshDashboard(this.props.negotiationId, updateOfferMessage, requestingParty);
    };
    UpdateOfferButton.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("button", { className: classNames('offer-action', {
                    'offer-action--accept': this.props.negotiationAction === rql_1.core_apimessages_NegotiationAction.ACCEPT,
                    'offer-action--reject': this.props.negotiationAction === rql_1.core_apimessages_NegotiationAction.REJECT,
                    'offer-action--counter': this.props.negotiationAction === rql_1.core_apimessages_NegotiationAction.COUNTER,
                }), onClick: this.toggleModal, type: "button" }, this.offerButtonText),
            React.createElement(update_offer_modal_1.default, { onRequestDialogClose: this.handleClose, isDialogOpen: this.state.openDialog, isSeller: this.props.isSeller, onSuccess: this.handleSuccess, listingId: this.props.listingId, negotiationId: this.props.negotiationId, negotiationAction: this.props.negotiationAction, shopChannel: rql_1.core_apimessages_Channel.REVERB })));
    };
    tslib_1.__decorate([
        bind_1.default
    ], UpdateOfferButton.prototype, "toggleModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], UpdateOfferButton.prototype, "handleClose", null);
    tslib_1.__decorate([
        bind_1.default
    ], UpdateOfferButton.prototype, "handleSuccess", null);
    return UpdateOfferButton;
}(React.Component));
exports.UpdateOfferButton = UpdateOfferButton;
exports.default = user_context_provider_1.withUserContext(UpdateOfferButton);
//# sourceMappingURL=update_offer_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/offers/update_offer_button.js
// module id = X76y
// module chunks = 20 21